'use strict';

var React = require('react');

var SvgTypeMajor = function SvgTypeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m7.077 12.5-.978 2.5h.401a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5h.488l4.314-11.023a.75.75 0 0 1 .814-.468 1 1 0 0 1 1.06.613l4.45 10.878h.874a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5h.465l-1.023-2.5h-4.865Zm.587-1.5 1.792-4.578 1.873 4.578h-3.665Z"
  }));
};
SvgTypeMajor.displayName = "TypeMajor";

exports.SvgTypeMajor = SvgTypeMajor;
